var global = require('../internals/global');

module.exports = global.Promise;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/native-promise-constructor.js
// module id = 530
// module chunks = 1